export const antdConfig = {
  form: {
    validateMessages: {
      required: "Es requerido llenar este campo"
    }
  }
}
